import { Component, Input } from '@angular/core';
import { BuilderQuestionSet } from '../../../../classes/questionnaire-builder/builder-question-set';
import { BuilderQuestionSetAlertThreshold } from '../../../../classes/questionnaire-builder/builder-question-set-alert-threshold';
import { AlertThresholdOperator } from '../../../../enums/alert-threshold-operator';
import { KeyValue } from '@angular/common';

@Component({
  selector: 'app-edit-question-set-alert-threshold',
  templateUrl: './edit-question-set-alert-threshold.component.html',
  standalone: false,
})
export class EditQuestionSetAlertThresholdComponent {
  @Input({ required: true }) questionSet!: BuilderQuestionSet;

  alertThresholdEnabled: boolean = false;

  ngOnInit(): void {
    if (this.questionSet.alertThreshold) {
      this.alertThresholdEnabled = true;
    }
  }

  onAlertToggleChanged(toggleValue: boolean) {
    if (toggleValue && !this.questionSet.alertThreshold) {
      // If toggling the alerts on, and a threshold does not exist, create a default one
      this.questionSet.alertThreshold = new BuilderQuestionSetAlertThreshold();
    } else {
      // If toggling the alerts off, set the threshold to null
      this.questionSet.alertThreshold = null;
    }
  }

  protected readonly AlertThresholdOperator = AlertThresholdOperator;

  // eslint-disable-next-line
  protected unsorted(a: KeyValue<any, any>, b: KeyValue<any, any>): number {
    return 0;
  }
}
